import { render, staticRenderFns } from "./ThumbView.vue?vue&type=template&id=628c24c0&"
import script from "./ThumbView.vue?vue&type=script&lang=js&"
export * from "./ThumbView.vue?vue&type=script&lang=js&"
import style0 from "./ThumbView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports